import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAccountsList,
  createOrUpdateAccount,
  deleteAccount,
  fetchAccountCode,
} from "./accountsThunks";

const accountsSlice = createSlice({
  name: "accounts",
  initialState: {
    accounts: [],
    loading: false,
    error: null,
    successMessage: null,
    selectedAccount: null,
    isEditAccount: false,
    accountCode: '',
  },
  reducers: {
    resetAccountManageStatus: (state) => {
      state.successMessage = null;
    },
    setSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
    },
    setIsEditAccount: (state, action) => {
      state.isEditAccount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAccountsList.fulfilled, (state, action) => {
        state.loading = false;

        const EXCLUDED_TYPES = ["creditor", "debitor"];

        state.accounts = (action.payload || []).filter(
          (acc) => !EXCLUDED_TYPES.includes(acc.acc_type_id)
        );
      })
      .addCase(createOrUpdateAccount.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteAccount.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(fetchAccountCode.fulfilled, (state, action) => {
        state.accountCode = action.payload;
      });
  },
});

export const {
  resetAccountManageStatus,
  setSelectedAccount,
  setIsEditAccount,
} = accountsSlice.actions;

export default accountsSlice.reducer;
